import type Component from "../Component";
import type Job from "../Job.ts";

export function getComponentsOfType<T>(job: Job<Component>, finder: (component: Component) => T | undefined): T[] {
    return Object
        .entries(job.components)
        .map(([, component]) => finder(component))
        .filter(component => component !== undefined)
}